import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import Api from '@/services';
import { notification } from 'antd';
const initState = {
    choosedDealers: undefined,
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /** 撮合成交 */
        doBrokeredDeal(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                return Api.order.brokeredDeal(payload).then((_r) => {
                    console.log('_r', _r);
                    return _r;
                }).catch((_e) => {
                    console.log('_e', _e);
                    return false;
                });
            });
        },
        /** 点击确定 */
        handleOk(payload, { update, state, rootState }) {
            const { choosedDealers } = rootState.brokeredDeal;
            const { sellerCode, goodsId, roundId, auctionId } = payload;
            let flag = false;
            let _params;
            payload.form.validateFields((error, values) => {
                if (choosedDealers === undefined) {
                    dispatch.searchDealers.SET_ERROR();
                    flag = true;
                }
                if (error) {
                    flag = true;
                }
                if (choosedDealers && !error) {
                    // 参数需要调整
                    _params = {
                        buyerCode: choosedDealers,
                        sellerCode,
                        goodsId,
                        roundId,
                        auctionId,
                        priorityOffer: values.dealPrice,
                        commission: values.servicePrice,
                        brokerage: values.commission,
                    };
                    // if (_params.auctionId === 'null') {
                    //   delete _params.auctionId;
                    // }
                    // if (_params.roundId === 'null') {
                    //   delete _params.roundId;
                    // }
                    // if (_params.goodsId === 'null') {
                    //   delete _params.goodsId;
                    // }
                    // if (_params.sellerCode === 'null') {
                    //   delete _params.sellerCode;
                    // }
                }
            });
            if (flag) {
                return;
            }
            this.doBrokeredDeal(_params).then((_r) => {
                if (_r) {
                    // 有 获取全部值 请求数据 成功后
                    notification.success({
                        message: '撮合成交成功',
                    });
                    payload.onOk();
                    dispatch.searchDealers.RESET_STATE();
                    this.RESET_STATE();
                    payload.form.resetFields();
                }
            });
        },
        /** 点击取消或叉号 */
        handleCancel(payload, { update, state, rootState }) {
            this.RESET_STATE();
            dispatch.searchDealers.RESET_STATE();
            payload.form.resetFields();
            if (payload.onCancel) {
                payload.onCancel();
            }
        },
        /** form input change */
        onChange(payload, { update, state, rootState }) {
            const { n, v, props } = payload;
            const { dealPrice, servicePrice, commission } = props.form.getFieldsValue();
            const _d = Number(dealPrice) || 0;
            const _s = Number(servicePrice) || 0;
            const _c = Number(commission) || 0;
            const _v = Number(v) || 0;
            switch (n) {
                case 'dealPrice':
                    props.form.setFieldsValue({
                        handPrice: _v * 1 + _s + _c,
                    });
                    break;
                case 'servicePrice':
                    props.form.setFieldsValue({
                        handPrice: _d * 1 + _v + _c,
                    });
                    break;
                case 'commission':
                    props.form.setFieldsValue({
                        handPrice: _d * 1 + _s + _v,
                    });
                    break;
                default:
                    console.warn('没有对应的价格变更');
            }
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                state[key] = payload[key];
            });
        },
    },
});
